import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import ScrollToTopOnPathChange from '~/b4b/components/ScrollToTopOnPathChange';
import { buildAppPath } from '~/b4b/utils/pathHelpers';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { GenerateReportsStep } from './steps/generate-reports-step/GenerateReportsStep';
import { SuccessStep } from './steps/success-step/SuccessStep';

export const GenerateReportsFlowController = () => {
  const basePath = buildAppPath('/reports');
  const returnToPath = urlBuilder.reports();

  return (
    <Router>
      <ScrollToTopOnPathChange />
      <FlowContextProvider basePath={basePath} returnToPath={returnToPath}>
        <Routes>
          <Route
            path={`${basePath}/new`}
            element={
              <StepWrapper name="new">
                <GenerateReportsStep />
              </StepWrapper>
            }
          />
          <Route
            path={`${basePath}/success`}
            element={<StepWrapper name="success">{stepProps => <SuccessStep {...stepProps} />}</StepWrapper>}
          />
        </Routes>
      </FlowContextProvider>
    </Router>
  );
};
